import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    checkAuthentication();
  }, [location]); // Re-check when location changes

  const checkAuthentication = async () => {
    try {
      console.log('🔍 Checking authentication...');
      
      // Check if user has valid Django session
      const response = await axios.get('/api/get-session-info/', {
        withCredentials: true, // CRITICAL: Include cookies
        headers: {
          'Content-Type': 'application/json',
        }
      });

      console.log('📊 Session info response:', response.data);

      // Check both Django auth AND subscription validation
      if (response.data.is_authenticated && response.data.subscription_validated) {
        console.log('✅ User is authenticated with valid subscription');
        setIsAuthenticated(true);
      } else if (response.data.subscription_validated && response.data.user_email) {
        // Has subscription but not Django authenticated - this is OK for middleware auth
        console.log('✅ User has valid subscription (middleware auth)');
        setIsAuthenticated(true);
      } else {
        console.log('❌ No valid authentication found');
        console.log('Is authenticated:', response.data.is_authenticated);
        console.log('Subscription validated:', response.data.subscription_validated);
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('❌ Authentication check failed:', error);
      
      // Check if error is 401 or network issue
      if (error.response?.status === 401) {
        console.log('401 Unauthorized - redirecting to subscription required');
      } else {
        console.error('Network or server error:', error.message);
      }
      
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#1890ff'
      }}>
        <div>
          <div style={{ marginBottom: '10px' }}>🔄 Verifying subscription...</div>
          <div style={{ fontSize: '14px', color: '#666' }}>Please wait...</div>
        </div>
      </div>
    );
  }

  // Redirect to subscription-required if not authenticated
  if (!isAuthenticated) {
    console.log('🚫 Not authenticated, redirecting to subscription-required');
    return <Navigate to="/subscription-required" replace />;
  }

  // Render the protected component
  console.log('✅ Rendering protected component');
  return children;
};

export default PrivateRoute;